import { ActivatedRouteSnapshot } from '@angular/router';

const findNearestRouteValue = <T>(
    route: ActivatedRouteSnapshot,
    accessorValue: (segment: ActivatedRouteSnapshot) => T
): T => {
    let segment = route;

    while (segment) {
        const routeValue = accessorValue(segment);
        if (routeValue) {
            return routeValue;
        } else {
            segment = segment.parent;
        }
    }

    return null;
};

const findNearestRouteParameter = <T>(route: ActivatedRouteSnapshot, paramName: string): T => {
    return findNearestRouteValue<T>(route, routeSnaphot => routeSnaphot.params[paramName]);
};

const findNearestRouteData = <T>(route: ActivatedRouteSnapshot, dataName: string): T => {
    return findNearestRouteValue<T>(route, routeSnaphot => routeSnaphot.data[dataName]);
};

const findQueryParamsData = <T>(route: ActivatedRouteSnapshot, dataName: string): T => {
    return findNearestRouteValue<T>(route, routeSnaphot => routeSnaphot.queryParams[dataName]);
};

export const routeSnapshotExtensions = {
    findParameter: findNearestRouteParameter,
    findData: findNearestRouteData,
    findQueryParams: findQueryParamsData,
};